import { CodeBlock } from './CodeBlock';
import { ItemDaDocumentacao } from './ItemDaDocumentacao';
import { TypeScale } from './TypeScale';

/**
 * Escala de referência — a mesma de docs/DESIGN-SYSTEM.md, seção 4. O título de
 * página é o do `PageHeader` (`text-3xl font-bold`): é o componente que toda
 * tela usa, e a escala aqui não pode dizer outra coisa.
 */
const ESCALA_INTER = [
  {
    name: 'Título de página',
    className: 'text-3xl font-bold tracking-tight',
    sizePx: '30px',
    weight: '700',
    sample: 'Credenciados',
  },
  {
    name: 'Título de seção',
    className: 'text-2xl font-bold',
    sizePx: '24px',
    weight: '700',
  },
  { name: 'Subtítulo', className: 'text-xl font-semibold', sizePx: '20px', weight: '600' },
  { name: 'Título de bloco', className: 'text-lg font-semibold', sizePx: '18px', weight: '600' },
  {
    name: 'Título de cartão',
    className: 'text-base font-semibold',
    sizePx: '16px',
    weight: '600',
  },
  {
    name: 'Corpo',
    className: 'text-sm',
    sizePx: '14px',
    weight: '400',
    sample: 'Transportadora Exemplo Ltda. — DRE Exemplo — Veículo AAA-0A00',
  },
  {
    name: 'Corpo forte',
    className: 'text-sm font-semibold',
    sizePx: '14px',
    weight: '600',
    sample: 'Termo de Adesão nº 0000/0000 — Ativo',
  },
  {
    name: 'Pequeno',
    className: 'text-xs',
    sizePx: '12px',
    weight: '400',
    sample: 'Atualizado há 5 minutos · 3 registros encontrados',
  },
  {
    name: 'Rótulo',
    className: 'text-[11px] font-semibold uppercase tracking-wider',
    sizePx: '11px',
    weight: '600',
    sample: 'Situação do credenciamento',
  },
  {
    name: 'Mínimo',
    className: 'text-[10px]',
    sizePx: '10px',
    weight: '400',
    sample: 'Gestão do sistema',
  },
];

const ESCALA_MONO = [
  {
    name: 'Código',
    className: 'text-sm font-mono',
    sizePx: '14px',
    weight: '400',
    sample: "const credenciado = await chamarApi('/credenciados/123')",
  },
  {
    name: 'Código pequeno',
    className: 'text-xs font-mono',
    sizePx: '12px',
    weight: '400',
    sample: 'hsl(var(--primary))',
  },
  {
    name: 'Valor monetário',
    className: 'text-2xl font-extrabold font-mono tracking-tight',
    sizePx: '24px',
    weight: '800',
    sample: 'R$ 45.320,00',
  },
];

export function TipografiaTab() {
  return (
    <div className="space-y-8">
      <ItemDaDocumentacao id="tipografia-inter">
        <section>
          <h3 className="text-lg font-semibold mb-1">Inter</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Família principal, pesos 300 a 800, carregada pelo Google Fonts no index.html
          </p>
          <div className="rounded-xl border border-border bg-card p-5">
            <TypeScale items={ESCALA_INTER} />
          </div>
        </section>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="tipografia-mono">
        <section>
          <h3 className="text-lg font-semibold mb-1">JetBrains Mono</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Família monoespaçada para número técnico — placa, CPF, CNPJ, valor —, pesos 400 a 600
          </p>
          <div className="rounded-xl border border-border bg-card p-5">
            <TypeScale items={ESCALA_MONO} fontFamily="mono" />
          </div>
        </section>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="tipografia-uso">
        <section>
          <h3 className="text-lg font-semibold mb-1">Uso recomendado</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Nenhuma tela escreve o próprio título: o <code>PageHeader</code> (
            <code>@/ui/PageHeader</code>) emite o único <code>h1</code> da página, em{' '}
            <code>text-3xl font-bold</code>, e é sempre o primeiro elemento visual — o desta própria
            página é um exemplo dele.
          </p>
          <CodeBlock
            code={`// Título de página: sempre pelo PageHeader, nunca um <h1> solto
<PageHeader title="Credenciados" description="Transportadores credenciados" />

// Rótulo de formulário
<label className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
  Nome do credenciado
</label>

// Valor monetário (mono)
<span className="text-2xl font-extrabold font-mono tracking-tight">R$ 45.320,00</span>

// Texto auxiliar
<p className="text-sm text-muted-foreground">Atualizado há 5 minutos</p>`}
          />
        </section>
      </ItemDaDocumentacao>
    </div>
  );
}
